import React from "react";
import { CommonModal } from "../../AbstractElements";
import { Row, Col } from "reactstrap";
import { deleteCustomerById } from "../../Services/Customer.service";
import { showAlert } from "../../Services/Shared.service";

const DeleteCustomer = ({
  Large,
  title,
  LargeModaltoggle,
  customerObj,
  setShowApiLoader,
  fetchCustomerData
}) => {
  const postDeleteCustomer = () => {
    const obj = {
      custId: customerObj.id,
    };
    setShowApiLoader(true);
    deleteCustomerById(obj)
      .then((res) => {
        setShowApiLoader(false);
        showAlert("success", "Customer Deleted");
        LargeModaltoggle();
        fetchCustomerData();
      })
      .catch((err) => {
        setShowApiLoader(false);
        showAlert("error", "Something went wrong");
      });
  };
  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={LargeModaltoggle}
      size="md"
    >
      <Row className="delete-customer">
        <Col xl="12" className="delete-customer-body">
                Are you sure you want to delete?
        </Col>
        <Col xl="12" className="delete-customer-footer">
          <button
            className="btn delete-customer-btn"
            onClick={() => postDeleteCustomer()}
          >
            Delete
          </button>
          <button className="btn cancel-delete-btn" onClick={()=>LargeModaltoggle()}>Cancel</button>
        </Col>
      </Row>
    </CommonModal>
  );
};

export default DeleteCustomer;
